import React, { createContext, useContext, useState, useCallback } from "react";
import panelAuthService from "../services/panelAuthService";

const PanelAuthContext = createContext(null);

export function PanelAuthProvider({ children }) {
  const [panel, setPanel] = useState(panelAuthService.getPanel());

  const login = useCallback(async (payload) => {
    const res = await panelAuthService.login(payload);
    panelAuthService.saveSession(res.data);
    setPanel(res.data.panel);
    return res.data.panel;
  }, []);

  const logout = useCallback(() => {
    panelAuthService.logout();
    setPanel(null);
  }, []);

  return (
    <PanelAuthContext.Provider value={{ panel, isAuthenticated: !!panel, login, logout }}>
      {children}
    </PanelAuthContext.Provider>
  );
}

export function usePanelAuth() {
  const ctx = useContext(PanelAuthContext);
  if (!ctx) throw new Error("usePanelAuth must be used within PanelAuthProvider");
  return ctx;
}
